/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */

import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { IonPopover, ModalController } from '@ionic/angular/standalone'
import { TranslateService } from '@ngx-translate/core'
import { Subscription } from 'rxjs'
import { ApiService } from '../../../../src/commons/services/api/api.service'
import { EmailUniquenessValidator } from '../../../../src/commons/validators/email-uniqueness.validator'
import { EmailDomainRestrictionValidator } from '../../../../src/commons/validators/email-domain-restriction.validator'
import { PlatformService } from '../../services/business/platform.service'
import { NotificationService } from '../../../../src/commons/services/ui/notification.service'
import { CacheService } from '../../../../src/commons/services/business/cache.service'
import { TitleService } from '../../../../src/commons/services/ui/title.service'
import { UserDto } from '../../../../src/security/models/user.model'
import { UserApiService } from '../../../../src/security/models/services/users/userApi.service'

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss'],
})
export class MyProfileComponent implements OnInit, OnDestroy {
  public userForm: FormGroup
  public showForm = false
  public userInfo: UserDto
  public domains: string[]
  private showErrorEmail = false
  public subscriptions: Subscription[] = []
  public callerTitle: string

  @Output() profileUpdate: EventEmitter<boolean> = new EventEmitter()
  @ViewChild('popoverDom') popoverDom: IonPopover
  @ViewChild('successMessage', { read: ElementRef }) successMessage: ElementRef

  constructor(
    private readonly translate: TranslateService,
    private userApiService: UserApiService,
    private modalController: ModalController,
    public platform: PlatformService,
    public apiService: ApiService,
    public notificationService: NotificationService,
    private cacheService: CacheService,
    private readonly titleAppService: TitleService,

  ) {
    this.userForm = new FormGroup({
      firstName: new FormControl('firstName', [Validators.required, Validators.maxLength(50)]),
      lastName: new FormControl('lastName', [Validators.required, Validators.maxLength(50)]),
      email: new FormControl('', [Validators.required, Validators.email, this.validateEmailDuplication],),
      phoneNumber: new FormControl('', Validators.pattern(new RegExp(/^(?=.{1,14}$)(\(\d{3}\)) (\d{3})-(\d{4})/))),
    })

    this.subscriptions.push(this.userForm.get('email').valueChanges.subscribe(() => (this.showErrorEmail = false)))
  }

  public async ngOnInit(): Promise<void> {
    this.titleAppService.setTitle(this.translate.instant('administration.myProfile.pageTitle'))
    this.userInfo = await this.cacheService.getUserInfo()
    const userDetails = await this.userApiService.getMyProfile()

    this.userForm.get('firstName').setValue(userDetails.firstName)
    this.userForm.get('lastName').setValue(userDetails.lastName)
    this.userForm.get('email').setValue(userDetails.email)
    this.userForm.get('phoneNumber').setValue(this.formatPhone(userDetails.phoneNumber ?? ''))
    this.showForm = true

    this.domains = await this.userApiService.getEmailDomainRestrictions()

    if (this.domains.length > 0)
      this.userForm.controls['email'].setValidators(
        Validators.compose([Validators.required, Validators.email, EmailDomainRestrictionValidator(this.domains)])
      )

    this.userForm.controls['email'].setAsyncValidators([
      EmailUniquenessValidator(this.apiService, this.userInfo.rId),
    ])
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((s) => {
      if (s) s.unsubscribe()
    })
  }

  public async dismissModal(): Promise<void> {
    this.titleAppService.setTitle(this.callerTitle, false)
    await this.modalController.dismiss()
  }

  public openDomains(event: MouseEvent): void {
    const rect: DOMRect = (event.target as HTMLElement).getBoundingClientRect()
    const newEvent = new MouseEvent('newMouseEvent', {
      ...event,
      clientX: rect.left,
      clientY: rect.top + rect.height,
    })
    void this.popoverDom.present(newEvent)
  }

  public async submit(): Promise<void> {
    this.showErrorEmail = false
    const values = this.userForm.value
    if (values.phoneNumber) {
      values.phoneNumber = values.phoneNumber.replace(/\(/g, '').replace(/\)/g, '').replace(/ /g, '-')
    }
    try {
      await this.userApiService.editMyProfile(values)
      this.userForm.markAsUntouched()
      this.userForm.markAsPristine()

      this.notificationService.showInlineMessage(this.successMessage)
      this.profileUpdate.emit(true)
    } catch (e) {
      if (e.status === 400) {
        this.showErrorEmail = true
        this.userForm.get('email').updateValueAndValidity()
      } else throw e
    }
  }

  public validateEmailDuplication = (): any => {
    let error = null
    if (this.showErrorEmail) {
      error = {
        emailConfirmationTriggered: true,
      }
    }
    return error
  }

  public formatPhone(chain: string): string {
    chain = chain.replace(/\(/g, '')
    chain = chain.replace(/\)/g, '')
    chain = chain.replace(/-/g, '')
    chain = chain.replace(/ /g, '')
    if (chain.length === 0) {
      chain = ''
    } else if (chain.length <= 3) {
      chain = chain.replace(/^(\d{0,3})/, '($1)')
    } else if (chain.length <= 6) {
      chain = chain.replace(/^(\d{0,3})(\d{0,3})/, '($1) $2')
    } else {
      chain = chain.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3')
    }
    return chain
  }
}
